import { Network, ArrowRight } from "lucide-react";
import { openSignIn } from "@/lib/signInModal";

export const BrokerPortalGate = ({ signedInAsWrongRole }) => (
  <div data-testid="broker-portal-gate" className="min-h-screen bg-rr-navy flex items-center justify-center px-5 relative overflow-hidden">
    <div className="grain-overlay" />
    <div className="max-w-md text-center relative">
      <div className="w-14 h-14 rounded-2xl bg-rr-orange/10 text-rr-orangeLight flex items-center justify-center mx-auto mb-5">
        <Network size={24} />
      </div>
      <h1 className="font-heading text-2xl md:text-3xl font-extrabold text-white">Broker Portal</h1>
      <p className="text-white/60 mt-3 leading-relaxed">
        {signedInAsWrongRole
          ? "Your account isn't registered as a broker yet. Sign in with a RelayRigs broker account to access the portal."
          : "Sign in with your RelayRigs broker account to manage your driver network, loads, and billing."}
      </p>
      <p className="text-white/40 text-xs mt-3">Broker accounts are launching soon — see our Brokers page for details.</p>
      <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
        <button onClick={() => openSignIn("login")} data-testid="broker-portal-gate-signin-button" className="inline-flex items-center gap-2 bg-rr-orange text-white font-bold px-7 py-3.5 rounded-full hover:bg-white hover:text-rr-navy transition-all">
          Sign In
        </button>
        <a href="/brokers" data-testid="broker-portal-gate-learn-more-link" className="inline-flex items-center gap-2 text-white/70 font-bold hover:text-white transition-colors">
          Learn About Brokers <ArrowRight size={15} />
        </a>
      </div>
    </div>
  </div>
);
